import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { Dialog, Button } from '@totalsoft/rocket-ui';
import DocumentScoringDimensionPeriodItemComponent from './DocumentScoringDimensionPeriodItemComponent';
import { compose } from 'redux';

const DocumentScoringDimensionPeriodListComponent = ({
  t,
  showModal,
  savingModal,
  periods,
  dimensions,
  onCloseLocalDimensionListModal,
  onSaveLocalPeriodDimensions,
  onPeriodDimensionChange,
  onAddNewPeriodDimension
}) => (
  <Dialog
    open={showModal}
    onClose={onCloseLocalDimensionListModal}
    aria-labelledby='periodDimensions-dialog-title'
    maxWidth='md'
    fullWidth
    title={t('DocumentEdit.Scoring.ScoringIndicator.Dimensions.Title')}
    content={
      periods && (
        <Grid container>
          <Grid item xs={12}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: '10%' }}>{t('DocumentEdit.Scoring.ScoringIndicator.Dimensions.Selected')}</TableCell>
                  <TableCell>{t('DocumentEdit.Scoring.ScoringIndicator.Dimensions.Year')}</TableCell>
                  <TableCell>{t('DocumentEdit.Scoring.ScoringIndicator.Dimensions.Month')}</TableCell>
                  <TableCell>{t('DocumentEdit.Scoring.ScoringIndicator.Dimensions.Indicator')}</TableCell>
                  <TableCell>{t('DocumentEdit.Scoring.ScoringIndicator.Dimensions.Period')}</TableCell>
                  <TableCell>{t('DocumentEdit.Scoring.ScoringIndicator.Dimensions.Source')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {periods &&
                  periods.map(({ document, validationInfo }, idx) => {
                    return (
                      <DocumentScoringDimensionPeriodItemComponent
                        disabled={document.isReadOnly}
                        key={document.documentScoringFinancialIndicatorPeriodDimensionId}
                        document={document}
                        validationInfo={validationInfo}
                        onPeriodDimensionChange={onPeriodDimensionChange(idx)}
                        dimensions={dimensions}
                      />
                    );
                  })}
              </TableBody>
            </Table>
          </Grid>
        </Grid>
      )
    }
    actions={
      <Grid container justifyContent='flex-end' spacing={2}>
        <Grid item>
          <Button color='primary' onClick={onAddNewPeriodDimension}>
            {t('Add')}
          </Button>
        </Grid>
        <Grid item>
          <Button color='primary' onClick={onSaveLocalPeriodDimensions} disabled={!periods.some(x => x.dirtyInfo.isDirty) || savingModal}>
            {savingModal ? t('Saving') + '...' : t('Save')}
          </Button>
        </Grid>
        <Grid item>
          <Button onClick={onCloseLocalDimensionListModal} color='primary' variant='outlined'>
            {t('Close')}
          </Button>
        </Grid>
      </Grid>
    }
  />
);

DocumentScoringDimensionPeriodListComponent.propTypes = {
  showModal: PropTypes.bool.isRequired,
  savingModal: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  onCloseLocalDimensionListModal: PropTypes.func.isRequired,
  dimensions: PropTypes.array,
  periods: PropTypes.array.isRequired,
  onSaveLocalPeriodDimensions: PropTypes.func.isRequired,
  onAddNewPeriodDimension: PropTypes.func.isRequired,
  onPeriodDimensionChange: PropTypes.func.isRequired
};

export default compose(withTranslation())(DocumentScoringDimensionPeriodListComponent);
